import { yoneticiMi } from "./giris.js";
import { yetkiliMi } from "./yetki.js";
import { BELGE_TURLERI, BELGE_TURU_ADI } from "./kutuk-belge.js";
import { BASINC_TESTI_HATLARI, DOSYA_GIRDI_TURLERI, DOSYA_GIRDI_TUR_ADI, GIRDI_YETKILERI, girdiIcerikTurleri, girdiIslemi, girdiYetkiliMi, kutukBelgeSinifi, } from "./riser-dosyasi.js";
import { HT_RET_AILESI } from "./set.js";
import { raporBaskaAile, raporDosyaBul } from "./rapor-dosya.js";
import { sokumRnBul } from "./sokum-rn.js";
import { montajDosyaAilesi, montajRnBul } from "./montaj-rn.js";
import { mrbSnBul } from "./mrb-sn.js";
/* ====================================================================================================================
 * 1 · Sabitler
 * ================================================================================================================== */
/**
 * Gelen kutusunun `dokuman.aile` değeri. Hiçbir rota adımı adı, aile sabiti ya da var olan sorgunun süzgeci bu değeri kullanmaz
 * (tire ve "inbox" sözcüğü): gelen kutusunun satırları hiçbir bugünkü sayıma girmez. Genel `POST /api/dokuman` bu aileyi reddeder.
 */
export const BELGE_GELEN_AILESI = "Documents-inbox";
/** Gelen kutusu satırlarının `dokuman.kaynak_ekran` değeri. */
export const BELGE_GELEN_KAYNAK_EKRAN = "belgeler";
/** Documents'in yükleme sınırı (MB). MRB intake, Registers ve Project documents kendi ekranlarında 200 MB alır (J24). */
export const GELEN_YUKLEME_SINIRI_MB = 100;
/** Dosyalama rezervasyonunun süresi: bu süre geçince başka biri dosyalamayı başlatabilir. */
export const DOSYALAMA_REZERVASYON_MS = 10 * 60 * 1000;
/** Gerekçe uzunluğu: "Mark reviewed", GEN-16 kararı (en az) ve referans / reddetme notu (en çok). */
export const GEREKCE_EN_AZ = 3;
export const GEREKCE_EN_COK = 500;
/**
 * Satırın kalıcı durumu: açık ya da kapanmış hâllerden biri. Kapanmış satır yeniden açılmaz (Faz 2'de de: dosyalanmış belgenin
 * sonradan çıkan kırmızı uyarısı ayrı kayıttır, satır "Filed · decision needed" görünür; belge-okuma.ts).
 */
export const GELEN_DURUMLARI = ["acik", "dosyalandi", "referans", "reddedildi", "donusturucu", "zaten_var"];
/** Saklanan dosyanın biçimi (baytlardan, sonra addan; `belgeBicimi`). */
export const BELGE_BICIMLERI = ["pdf", "jpeg", "png", "xlsx", "xls", "csv", "word"];
/** Biçimin ekran adı ("A {0} file cannot be filed as {1}.", GEN-16'nın "{0}"ı). Değer adıdır, çevrilmez. */
export const BICIM_ADI = { pdf: "PDF", jpeg: "JPG", png: "PNG", xlsx: "Excel", xls: "Excel", csv: "CSV", word: "Word" };
/** Dosyalamada kapıya giden dosyanın MIME'ı (J5): saklı MIME boş ya da "application/octet-stream" olabilir. */
export const BICIM_MIME = {
    pdf: "application/pdf",
    jpeg: "image/jpeg",
    png: "image/png",
    xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    xls: "application/vnd.ms-excel",
    csv: "text/csv",
    word: "application/octet-stream",
};
/**
 * Görme sınıfı (plan §5.7, K26): türden hesaplanır (`gelenSinifi`). belirsiz = tür seçilmedi · diger = "Other (reference only)" ·
 * acik = herkes görür · kutuk = kütük belgesi · kisisel = kişisel belge (WPQ, süreklilik, NDT sertifikası) · fiyat = fiyat taşır.
 */
export const GELEN_SINIFLARI = ["belirsiz", "diger", "acik", "kutuk", "kisisel", "fiyat"];
/* ====================================================================================================================
 * 2 · Biçim
 * ================================================================================================================== */
const WORD_UZANTI = /\.(?:doc|docx|docm|rtf|odt)$/i;
const bas = (b, imza) => b.length >= imza.length && imza.every((x, i) => b[i] === x);
const PDF_IMZA = [0x25, 0x50, 0x44, 0x46, 0x2d]; // %PDF-
const JPEG_IMZA = [0xff, 0xd8, 0xff];
const PNG_IMZA = [0x89, 0x50, 0x4e, 0x47, 0x0d, 0x0a, 0x1a, 0x0a];
const RTF_IMZA = [0x7b, 0x5c, 0x72, 0x74, 0x66]; // {\rtf
const ZIP_IMZA = [0x50, 0x4b]; // PK (xlsx, docx, odt)
const OLE_IMZA = [0xd0, 0xcf, 0x11, 0xe0]; // eski Office (xls, doc)
/**
 * Dosyanın biçimi (J5, kesin kural): önce baytlar karar verir. `%PDF-` → pdf (adı ne olursa olsun) · JPEG / PNG imzası → resim ·
 * `{\rtf` → word · `PK` → adı .xlsx ise xlsx, .docx/.docm/.odt ise word, değilse kabul edilmez · OLE → adı .xls ise xls, .doc ise
 * word, değilse kabul edilmez · bilinen imza yoksa adı .csv ise csv, Word uzantılıysa word, değilse kabul edilmez (null).
 * Adı .pdf olan ama PDF olmayan dosya (ör. yeniden adlandırılmış .docx) saklanmaz.
 */
export function belgeBicimi(ad, baytlar) {
    const a = (ad ?? "").trim();
    const b = baytlar ?? [];
    if (bas(b, PDF_IMZA))
        return "pdf";
    if (bas(b, JPEG_IMZA))
        return "jpeg";
    if (bas(b, PNG_IMZA))
        return "png";
    if (bas(b, RTF_IMZA))
        return "word";
    if (bas(b, ZIP_IMZA)) {
        if (/\.xlsx$/i.test(a))
            return "xlsx";
        return /\.(?:docx|docm|odt)$/i.test(a) ? "word" : null;
    }
    if (bas(b, OLE_IMZA)) {
        if (/\.xls$/i.test(a))
            return "xls";
        return /\.doc$/i.test(a) ? "word" : null;
    }
    if (/\.csv$/i.test(a))
        return "csv";
    return WORD_UZANTI.test(a) ? "word" : null;
}
/* ====================================================================================================================
 * 3 · Tür sözlüğü
 * ================================================================================================================== */
/** Dönüştürücülü aileler (bugünkü toplu kapılar). */
export const DONUSTURUCU_AILELERI = ["mrb", "disposition", "rework", "sokum", "montaj"];
/** Ailenin kısa adı (olay metni, yer metni). Değer adlarıdır, çevrilmez. */
export const DONUSTURUCU_AILE_ADI = { mrb: "MRB", disposition: "Disposition", rework: "Rework", sokum: "FM-0011", montaj: "FM-0012" };
/** Ailenin kapısının yetkisi (kapının `@Yetki`'si; Documents bunu yalnız düğmeyi göstermek ve devri başlatmak için okur). */
export const DONUSTURUCU_YETKISI = { mrb: "mrb", disposition: "evrak", rework: "dogrula", sokum: "sokum", montaj: "evrak" };
/** "What is this file?" seçiminin grupları (ekrandaki sırayla). */
export const GELEN_GRUPLARI = ["Registers", "Finishing", "Component", "Weld map", "Project documents", "Converter types", "Filed on another screen", "Other"];
const tanimlar = {};
for (const kutuk of Object.keys(BELGE_TURLERI)) {
    for (const tur of BELGE_TURLERI[kutuk]) {
        tanimlar[`kutuk:${kutuk}:${tur}`] = {
            ad: BELGE_TURU_ADI[kutuk][tur] ?? tur, grup: "Registers", hedef: "kutuk", kabul: ["pdf"], sinif: kutukBelgeSinifi(kutuk, tur),
            yetki: ["belgeKutuk"], kutuk, belgeTuru: tur,
        };
    }
}
tanimlar.ht = { ad: "Hydrotest certificate", grup: "Finishing", hedef: "ht", kabul: ["pdf"], sinif: "acik", yetki: ["evrak"], sinirMb: 100 };
tanimlar.hat_ndt = { ad: "Finishing NDT report", grup: "Finishing", hedef: "hat_ndt", kabul: ["pdf"], sinif: "acik", yetki: ["evrak"], sinirMb: 100 };
tanimlar.boya = { ad: "Coating report (GOE)", grup: "Finishing", hedef: "boya", kabul: ["pdf", "jpeg", "png"], sinif: "acik", yetki: ["evrak"], sinirMb: 100 };
tanimlar.adim_raporu = { ad: "Step report (NDT, DPI, MPI, PWHT)", grup: "Component", hedef: "adim_raporu", kabul: ["pdf"], sinif: "acik", yetki: ["ndtYukle"], sinirMb: 100 };
/** D-074 Faz 2 · PR 11: PWHT grafiği (plan M13); dosyalama adım raporu yolu, aktif PWHT adımına. */
tanimlar.pwht = { ad: "PWHT chart", grup: "Component", hedef: "pwht", kabul: ["pdf"], sinif: "acik", yetki: ["ndtYukle"], sinirMb: 100 };
tanimlar.urun_geldi = { ad: "Product arrived (3.1)", grup: "Component", hedef: "urun_geldi", kabul: ["pdf", "jpeg", "png"], sinif: "acik", yetki: ["planla"], sinirMb: 30 };
tanimlar.weldmap = { ad: "Weld map (PDF)", grup: "Weld map", hedef: "weldmap", kabul: ["pdf"], sinif: "acik", yetki: ["weldMapPdf"], sinirMb: 60 };
for (const t of Object.keys(DOSYA_GIRDI_TURLERI)) {
    tanimlar[`proje:${t}`] = {
        ad: DOSYA_GIRDI_TUR_ADI[t], grup: "Project documents", hedef: "proje", kabul: girdiIcerikTurleri(t), sinif: DOSYA_GIRDI_TURLERI[t].sinif,
        yetki: GIRDI_YETKILERI[girdiIslemi(t)], proje: t, sinirMb: 200,
    };
}
const DONUSTURUCU_TUR_ADI = {
    mrb: { pdf: "MRB (Complete PDF)", excel: "MRB content excel" },
    disposition: { pdf: "Disposition report", excel: "Inspection input excel" },
    rework: { pdf: "Rework report", excel: "Rework transition excel" },
    sokum: { pdf: "Disassembly report (FM-0011, old)", excel: "Disassembly input excel" },
    montaj: { pdf: "Assembly report (FM-0012)", excel: "Assembly input excel" },
};
for (const aile of DONUSTURUCU_AILELERI) {
    for (const parca of ["pdf", "excel"]) {
        tanimlar[`donusturucu:${aile}:${parca}`] = {
            ad: DONUSTURUCU_TUR_ADI[aile][parca], grup: "Converter types", hedef: "donusturucu", kabul: parca === "pdf" ? ["pdf"] : ["xlsx"], sinif: "acik",
            yetki: [DONUSTURUCU_YETKISI[aile]], donusturucu: { aile, parca }, sinirMb: aile === "mrb" ? 200 : 100,
        };
    }
}
const baskaEkran = (ad, ekranlar) => ({ ad, grup: "Filed on another screen", hedef: null, kabul: [], sinif: "acik", yetki: [], ekranlar });
tanimlar["ekran:adim_dosyasi"] = baskaEkran("Inserted step file", [{ ad: "Component", yol: "/komponent" }]);
tanimlar["ekran:foto"] = baskaEkran("Photo", [
    { ad: "Receiving", yol: "/teslim" }, { ad: "Disassembly", yol: "/sokum" }, { ad: "Component", yol: "/komponent" }, { ad: "Fit-up", yol: "/fitup" }, { ad: "Weld map", yol: "/weldmap" },
]);
tanimlar["ekran:sokum_imzali"] = baskaEkran("Signed disassembly print-out (OASIS form)", [{ ad: "Disassembly", yol: "/sokum" }]);
tanimlar["ekran:batch_rn"] = baskaEkran("Batch RN list", [{ ad: "Admin", yol: "/admin" }]);
tanimlar["ekran:saha_survrep"] = baskaEkran("Field list SURVREP", [{ ad: "Field list", yol: "/saha" }]);
/**
 * J3: "Other" içeriği bilinmeyen dosyadır; herkese açılmaz (sınıf `diger`). D-074 Faz 3 (K20): fatura Registers › Stock türüdür
 * (`kutuk:stok_paket:fatura`); bu "reference only" anahtarı eski satırlar için kalıcıdır, seçimde yerinde kalır.
 */
tanimlar.diger = { ad: "Other (reference only)", grup: "Other", hedef: null, kabul: [], sinif: "diger", yetki: [] };
tanimlar.fatura = { ad: "Commercial invoice (reference only)", grup: "Other", hedef: null, kabul: [], sinif: "fiyat", yetki: [] };
/** Tür sözlüğü: anahtar → tanım. Anahtar `belge_gelen.tur`da saklanır (kalıcı değer adları). */
export const GELEN_TURLERI = tanimlar;
export const gelenTuruMu = (t) => typeof t === "string" && Object.hasOwn(GELEN_TURLERI, t);
export const gelenTuruAdi = (t) => (t && gelenTuruMu(t) ? GELEN_TURLERI[t].ad : null);
/** Görme sınıfı türden (I6: belirsiz ⇔ tür yok). Bilinmeyen anahtar belirsiz sayılır. */
export function gelenSinifi(tur) {
    return tur && gelenTuruMu(tur) ? GELEN_TURLERI[tur].sinif : "belirsiz";
}
/** Hedefin tür anahtarı (dönüştürücüde parça satırın biçiminden: xlsx → excel). */
export function hedefTuru(h, bicim) {
    switch (h.tur) {
        case "kutuk": return `kutuk:${h.kutuk}:${h.belgeTuru}`;
        case "proje": return `proje:${h.belgeTuru}`;
        case "donusturucu": return `donusturucu:${h.aile}:${bicim === "xlsx" ? "excel" : "pdf"}`;
        default: return h.tur;
    }
}
/** Hedef satırın türüne uyuyor mu (türü seçilmiş satır). */
export const hedefUyarMi = (tur, h, bicim) => tur !== null && hedefTuru(h, bicim) === tur;
/**
 * Dosya adından ipucu (plan §5.2 adım 4): YALNIZ bugünkü toplu pencerelerin ad tanıyıcıları. MRB sözcüğü geçen ad MRB (SN `mrbSnBul`);
 * `raporDosyaBul` türü okuyabildiği ve ad başka bir aile söylemediği ad Disposition / Rework; adında söküm sözcüğü geçen FM-0011
 * (riser `sokumRnBul`); Assembly ya da TRACE SHEET geçen FM-0012 (riser `montajRnBul`). Biçim xlsx ise excel türü, değilse PDF
 * türü önerilir. Başka hiçbir ad tahmin edilmez (hidrotest sertifikası, packing list, kalibrasyon adı ipucu vermez): "ad tek başına
 * güven değildir". Ekranda "From the file name (a hint only)" ile gösterilir.
 */
export function adIpucu(ad, bicim) {
    const a = ad ?? "";
    const parca = (bicim ?? (/\.xlsx\s*$/i.test(a) ? "xlsx" : "pdf")) === "xlsx" ? "excel" : "pdf";
    const u = a.toUpperCase();
    const tur = (aile) => `donusturucu:${aile}:${parca}`;
    if (/(?:^|[^A-Z])MRB(?:[^A-Z]|$)/.test(u))
        return { tur: tur("mrb"), rn: null, sn: mrbSnBul(a), hat: null };
    const r = raporDosyaBul(a);
    if (r.tur && !raporBaskaAile(a))
        return { tur: tur(r.tur), rn: r.rn, sn: null, hat: null };
    const m = montajDosyaAilesi(a);
    if (m === "disassembly")
        return { tur: tur("sokum"), rn: sokumRnBul(a), sn: null, hat: null };
    if (m === "assembly")
        return { tur: tur("montaj"), rn: montajRnBul(a), sn: null, hat: null };
    return null;
}
const ekler = (s) => (Array.isArray(s.ekYukleyenler) ? s.ekYukleyenler.filter((e) => Boolean(e) && typeof e.id === "string") : []);
/** İlk yükleyen ("kendi satırı" işlemleri: türü seçmek, gerekçesiz reddetmek, referans). */
export const ilkYukleyenMi = (i, s) => s.yukleyenId === i.id;
/** Yükleyen: ilk yükleyen ya da aynı baytları satır açıkken yükleyen öteki kişi (J4). Görmede yükleyen sayılır. */
export const yukleyenMi = (i, s) => ilkYukleyenMi(i, s) || ekler(s).some((e) => e.id === i.id);
const kaliteLideriMi = (r) => r === "kalite_lideri";
const sahaInspektoruMu = (r) => r === "saha_inspektoru";
/**
 * Satırın kişiye görünümü (plan §5.7 "Görme", K26, J2-J4). PM ve sistem yöneticisi her satırı tam görür.
 * - belirsiz (türsüz) ve diger: kalite lideri, saha inspektörü (J2) ve yükleyen tam; öteki roller göremez.
 * - acik: herkes tam.
 * - kutuk: kalite lideri (K2 dosyalayanı) ve yükleyen tam; öteki roller göremez.
 * - kisisel: kalite lideri yalnız kendi yüklediğini tam görür; öteki yükleyen maskeli ("uploaded"); öteki roller göremez.
 * - fiyat: müşteri siparişi (Project documents) kalite liderine tam (bugünkü Project documents kuralı); PO ve fatura kalite liderine
 *   yalnız kendi yüklediyse maskeli; yükleyen maskeli; öteki roller göremez.
 */
export function gelenGorunumu(i, s) {
    if (yoneticiMi(i.rol))
        return "tam";
    const sinif = gelenSinifi(s.tur);
    const yukleyen = yukleyenMi(i, s);
    switch (sinif) {
        case "acik":
            return "tam";
        case "belirsiz":
        case "diger":
            return yukleyen || kaliteLideriMi(i.rol) || sahaInspektoruMu(i.rol) ? "tam" : "yok";
        case "kutuk":
            return yukleyen || kaliteLideriMi(i.rol) ? "tam" : "yok";
        case "kisisel":
            if (kaliteLideriMi(i.rol))
                return yukleyen ? "tam" : "yok";
            return yukleyen ? "yuklendi" : "yok";
        case "fiyat":
            if (s.tur === "proje:musteri_siparisi" && girdiYetkiliMi(i.rol, "belge"))
                return "tam";
            return yukleyen ? "yuklendi" : "yok";
    }
}
/**
 * Türün gizlilik sırası: 3 fiyatlı (PO, fatura) · 2 kişisel · 1 müşteri siparişi (fiyatlı ama Project documents'ta kalite liderine
 * açık) · 0 öteki. Büyük olan daha az kişiye görünür.
 */
export function gizlilikSirasi(tur) {
    const s = gelenSinifi(tur);
    if (s === "fiyat")
        return tur === "proje:musteri_siparisi" ? 1 : 3;
    return s === "kisisel" ? 2 : 0;
}
/**
 * Aynı baytların OASIS'te bilinen en sıkı kişisel ya da fiyatlı türü (inceleme bulgusu, U-073): kişisel ya da fiyatlı olarak
 * dosyalanmış bir dosya biri tarafından türsüz yeniden yüklenince yeni satır türsüz açılıyor, kalite lideri ve saha inspektörü dosyayı
 * açabiliyordu (görme sınıfı yalnız yeni satırın boş türüne bakıyordu). Adaylar sunucudan gelir: kütük bağlarının türü
 * (`kutuk:<kütük>:<tür>`), Project documents bağlarının türü (`proje:<tür>`) ve kapanmış gelen kutusu satırlarının türü. Kişisel ya da
 * fiyatlı aday yoksa null.
 */
export function kopyaGizliTuru(adaylar) {
    let en = null;
    for (const t of adaylar)
        if (t && gelenTuruMu(t) && gizlilikSirasi(t) > gizlilikSirasi(en))
            en = t;
    return en;
}
/**
 * K2 (uygulandı, 27.10.2026): Registers belgesini Documents'ten kalite lideri de dosyalar (`belgeKutuk`), fiyatlı olan (PO, fatura) hariç;
 * kişisel belgeyi (WPQ, süreklilik, NDT sertifikası) yalnız kendi yüklediyse. PM ve sistem yöneticisi her belgeyi.
 */
export function kutukDosyalayabilirMi(i, kutuk, belgeTuru, s) {
    if (yoneticiMi(i.rol))
        return true;
    if (!yetkiliMi(i.rol, "belgeKutuk"))
        return false;
    const sinif = kutukBelgeSinifi(kutuk, belgeTuru);
    if (sinif === "fiyat")
        return false;
    if (sinif === "kisisel")
        return yukleyenMi(i, s);
    return true;
}
/** Kütük dosyalamasının ret cümlesi (403): PO ve fatura (D-074 Faz 3, K20) ayrı cümle. */
export const KUTUK_YETKI_METNI = "Registers documents are filed by the Quality Lead, the PM or the System administrator.";
export const KUTUK_PO_YETKI_METNI = "A PO is filed by the PM or the System administrator.";
export const KUTUK_FATURA_YETKI_METNI = "A commercial invoice is filed by the PM or the System administrator.";
export const kutukYetkiMetni = (belgeTuru) => belgeTuru === "po" ? KUTUK_PO_YETKI_METNI : belgeTuru === "fatura" ? KUTUK_FATURA_YETKI_METNI : KUTUK_YETKI_METNI;
/** Kişi satırın SEÇİLİ türünü bugünkü yolundan dosyalayabilir mi (yetki; biçim ve satır durumu ayrıca). */
export function dosyalayabilirMi(i, s) {
    if (!s.tur || !gelenTuruMu(s.tur))
        return false;
    const t = GELEN_TURLERI[s.tur];
    if (!t.hedef)
        return false;
    if (t.hedef === "kutuk")
        return kutukDosyalayabilirMi(i, t.kutuk, t.belgeTuru, s);
    return t.yetki.some((x) => yetkiliMi(i.rol, x));
}
/** 403 cümlesinin yetkisi (YetkiGuard'ın `yetkiMetni` kalıbı): türün ilk yetkisi. */
export const dosyalamaIslemi = (tur) => (gelenTuruMu(tur) ? (GELEN_TURLERI[tur].yetki[0] ?? null) : null);
/** Satırın türü dosyalanmayan (yalnız referans ya da başka ekranda) bir tür mü: türsüz, "Other", fatura, "Filed on another screen". */
const dosyalanmazMi = (tur) => !tur || !gelenTuruMu(tur) || GELEN_TURLERI[tur].hedef === null;
/** Kişi satırın türünü seçebilir mi (§3.4): ilk yükleyen, kalite lideri, türsüz ya da "Other" satırda saha inspektörü (J2), PM, sistem yöneticisi, ya da bugünkü türü dosyalayabilen. */
export function turSecebilirMi(i, s) {
    if (yoneticiMi(i.rol) || kaliteLideriMi(i.rol) || ilkYukleyenMi(i, s))
        return true;
    if (sahaInspektoruMu(i.rol) && (s.tur === null || gelenSinifi(s.tur) === "diger"))
        return true;
    return dosyalayabilirMi(i, s);
}
/**
 * "File as reference" (§3.10, J2, J20): Word satırında yalnız `belgeUyari` (kalite lideri; PM, sistem yöneticisi), gerekçeyle. Öteki
 * satırda ilk yükleyen, kalite lideri, PM, sistem yöneticisi, türsüz / "Other" / başka ekranda dosyalanan satırda saha inspektörü,
 * ya da seçili türü dosyalayabilen.
 */
export function referansYapabilirMi(i, s) {
    if (s.bicim === "word")
        return yetkiliMi(i.rol, "belgeUyari");
    if (yoneticiMi(i.rol) || kaliteLideriMi(i.rol) || ilkYukleyenMi(i, s))
        return true;
    if (sahaInspektoruMu(i.rol) && dosyalanmazMi(s.tur))
        return true;
    return dosyalayabilirMi(i, s);
}
/**
 * "Reject" (§3.11): ilk yükleyen (yüklemesini geri çeker), kalite lideri, PM, sistem yöneticisi ya da seçili türü dosyalayabilen.
 * Word satırında ilk yükleyen dışındaki kişi `belgeUyari` ister ve gerekçe yazar (karar satırı).
 */
export function reddedebilirMi(i, s) {
    if (ilkYukleyenMi(i, s))
        return true;
    if (s.bicim === "word")
        return yetkiliMi(i.rol, "belgeUyari");
    return yoneticiMi(i.rol) || kaliteLideriMi(i.rol) || dosyalayabilirMi(i, s);
}
/** Reddetme gerekçe ve karar satırı ister mi: Word satırı, ilk yükleyen dışındaki kişi. */
export const reddetmeKarariMi = (i, s) => s.bicim === "word" && !ilkYukleyenMi(i, s);
/**
 * GEN-01 kapanışı ("Remove from this list") için eşleşen ailenin dosyalama yetkileri. Bugünkü yolların aileleri; adım raporlarının
 * ailesi adım adıdır (NDT, DPI, MPI, PWHT, Hardness geçen ad).
 */
export function aileIslemleri(aile) {
    switch (aile) {
        case "Hydrotest": return ["evrak", "ndtYukle"];
        case HT_RET_AILESI: return ["evrak"];
        case "NDT":
        case "Coating-GOE":
        case "Disposition":
        case "Inspection-input":
        case "SURVREP": return ["evrak"];
        case "Weld map": return ["weldMapPdf"];
        case "EN10204-3.1": return ["planla", "belgeKutuk"];
        case "Register document":
        case "Stock certificate": return ["belgeKutuk"];
        case "Project document": return ["mrb", "evrak"];
        case "MRB":
        case "MRB-icerik": return ["mrb"];
        case "SURVREP-rework":
        case "Rework-gecis": return ["dogrula"];
        default:
            if (!aile)
                return [];
            if (/^FM-0011/.test(aile))
                return ["sokum"];
            if (/^FM-0012/.test(aile))
                return ["evrak"];
            if (/NDT|DPI|MPI|PWHT|Hardness/.test(aile))
                return ["ndtYukle"];
            return [];
    }
}
/** "Remove from this list" (§3.13): ilk yükleyen, kalite lideri, PM, sistem yöneticisi ya da eşleşen ailelerden birinin dosyalayanı. */
export function zatenVarKapatabilirMi(i, s, eslesenAileler) {
    if (yoneticiMi(i.rol) || kaliteLideriMi(i.rol) || ilkYukleyenMi(i, s))
        return true;
    return eslesenAileler.some((a) => aileIslemleri(a).some((x) => yetkiliMi(i.rol, x)));
}
const zaman = (v) => (v === null || v === undefined ? null : new Date(v).getTime());
/** Satırda süresi dolmamış bir dosyalama rezervasyonu var mı. */
export function rezervasyonAktifMi(s, simdi) {
    const t = zaman(s.dosyalamaBasTs);
    return Boolean(s.dosyalayanId) && t !== null && simdi.getTime() - t < DOSYALAMA_REZERVASYON_MS;
}
/** Satır şu anda BAŞKA biri tarafından dosyalanıyor mu (J9: öteki yazımlar 409). */
export const baskasiDosyaliyorMu = (i, s, simdi) => rezervasyonAktifMi(s, simdi) && s.dosyalayanId !== i.id;
export const GELEN_ETIKET_ADI = {
    yuklendi: "Uploaded",
    yetkili_bekleniyor: "Waiting for someone who can file",
    dosyalaniyor: "Filing…",
    karar_bekliyor: "Needs decision",
    dosyalandi: "Filed",
    referans: "Filed as reference",
    donusturucu: "Sent to converter",
    reddedildi: "Rejected upload",
    zaten_var: "Already in OASIS",
    okuma_sirasinda: "Waiting for reading",
    okunuyor: "Reading",
    onay_bekliyor: "Needs confirmation",
    riser_bekliyor: "Waiting for its riser",
    adim_bekliyor: "Waiting for the step",
    yer_bekliyor: "Needs owner",
    okunamadi: "Could not read",
    dosyalandi_karar: "Filed · decision needed",
};
const rolMu = (r) => ["pm", "kalite_lideri", "saha_inspektoru", "formen", "test_teknisyeni", "saha_supervizoru", "sistem_yoneticisi"].includes(r);
/**
 * Satırın görünen durumu. Kapalı satırda kalıcı durum; dosyalanmış satırın güncel okumasında kararsız kırmızı uyarı varsa "Filed ·
 * decision needed" (satır açılmaz). Açık satırda: dosyalanıyor · Word (karar bekliyor) · okuma durumu (D-074 Faz 2: okuma sırasında,
 * okunuyor, okunamadı, bekleme durumları; okunmuş satırda kırmızı varsa karar bekliyor, yoksa yükleyen dosyalayamıyorsa yetkili bekleniyor,
 * değilse onay bekliyor) · yetkili bekleniyor · yüklendi. "Waiting for someone who can file": türü seçilmiş, dosyalanan bir tür ve
 * yükleyenin (yüklediği andaki rolüyle) yetkisi yok. `kirmiziAcik`: güncel okumada kararsız kırmızı uyarı (sunucu hesaplar).
 */
export function gelenEtiketi(s, simdi, kirmiziAcik = false) {
    if (s.durum !== "acik") {
        if (s.durum === "dosyalandi" && kirmiziAcik)
            return "dosyalandi_karar";
        return (GELEN_DURUMLARI.includes(s.durum) ? s.durum : "dosyalandi");
    }
    if (rezervasyonAktifMi(s, simdi))
        return "dosyalaniyor";
    if (s.bicim === "word")
        return "karar_bekliyor";
    const yetkiliYok = !dosyalanmazMi(s.tur) && rolMu(s.yukleyenRol) && !dosyalayabilirMi({ id: s.yukleyenId, rol: s.yukleyenRol }, s);
    switch (s.okumaDurumu) {
        case "sirada": return "okuma_sirasinda";
        case "okunuyor": return "okunuyor";
        case "okunamadi": return "okunamadi";
        case "riser_bekliyor": return "riser_bekliyor";
        case "adim_bekliyor": return "adim_bekliyor";
        case "yer_bekliyor": return "yer_bekliyor";
        case "okundu": return kirmiziAcik ? "karar_bekliyor" : yetkiliYok ? "yetkili_bekleniyor" : "onay_bekliyor";
    }
    if (yetkiliYok)
        return "yetkili_bekleniyor";
    return "yuklendi";
}
/**
 * "Needs me" (§6.3): açık, tam görünen, başkasının rezervasyonunda olmayan ve şunlardan biri: Word satırı ve kişi karar verebilir
 * (`belgeUyari`); dosyalanmayan türde (türsüz, "Other", başka ekranda; Word satırı da) kendi yüklemesi ya da kişi kalite lideri, saha
 * inspektörü (J2), PM, sistem yöneticisi; dosyalanan türde kişi o türü dosyalayabilir. İnceleme bulgusu (U-073): türsüz Word satırı
 * önce "karar verebilen" kuralına takılıyor, yükleyenin ve saha inspektörünün "Needs me"sine düşmüyordu (onaylı belgeler--faz1:
 * saha inspektörünün Needs me'si 4, türsüz Word dosyası dahil); ikisi de satırın türünü seçebilir, yükleyen geri çekebilir.
 * D-074 Faz 2 · PR 8 (T24): `kararBende` (sunucu hesaplar: satırın etkin okumasında kişinin karar verebileceği kararsız kırmızı var) ise satır
 * kişinin "Needs me"sindedir: kalite lideri kırmızı açık hidrotest satırını görür (plan §5.7 "Kırmızıyı kim kapatır: Kalite lideri"); karar
 * bekleyen satır karar verenin listesinde olmazsa kimsenin işi olmazdı. Varsayılan false: öteki kurallar değişmez.
 */
export function bendeMi(i, s, simdi, kararBende = false) {
    if (s.durum !== "acik" || gelenGorunumu(i, s) !== "tam" || baskasiDosyaliyorMu(i, s, simdi))
        return false;
    if (kararBende)
        return true;
    const dosyalanmaz = dosyalanmazMi(s.tur);
    const turBekleyen = dosyalanmaz && (yukleyenMi(i, s) || yoneticiMi(i.rol) || kaliteLideriMi(i.rol) || sahaInspektoruMu(i.rol));
    if (s.bicim === "word")
        return yetkiliMi(i.rol, "belgeUyari") || turBekleyen;
    if (dosyalanmaz)
        return turBekleyen;
    return dosyalayabilirMi(i, s);
}
export const FAZ1_UYARI_KODLARI = ["KAL-04", "NDT-01", "WPQ-08", "HT-10", "GEN-16", "GEN-01", "GEN-05", "GEN-07", "GEN-08"];
/** Kayıt uyarıları (Documents › Alerts, zil, "Mark reviewed"). */
export const KAYIT_UYARI_KODLARI = ["KAL-04", "NDT-01", "WPQ-08", "HT-10"];
export const SURE_UYARI_GUN = 30;
/**
 * Süre uyarısı (J14): bitiş günü saklı ISO metnin ilk 10 karakteridir (kolon gün başı UTC; D-064 kuralı, `sertifikaDurumu`); bitiş
 * günü kendisi hâlâ geçerlidir. "Bugün + 30" `YYYY-MM-DD` metni üzerinde UTC ile hesaplanır (yerel saat aritmetiği yok). Tarihsiz
 * kayıt uyarı vermez.
 */
export function sureUyarisi(bitis, bugun) {
    if (bitis === null || bitis === undefined || bitis === "")
        return null;
    const g = (bitis instanceof Date ? bitis.toISOString() : String(bitis)).slice(0, 10);
    if (!/^\d{4}-\d{2}-\d{2}$/.test(g))
        return null;
    if (g < bugun)
        return "doldu";
    const sinir = new Date(new Date(`${bugun}T00:00:00.000Z`).getTime() + SURE_UYARI_GUN * 86_400_000).toISOString().slice(0, 10);
    return g <= sinir ? "yaklasiyor" : null;
}
/** "Since" / zil zamanı: dolan uyarıda bitiş günü, yaklaşan uyarıda bitiş − 30 gün (ISO gün). */
export function sureUyariBaslangici(bitisGunu, evre) {
    if (evre === "doldu")
        return bitisGunu;
    return new Date(new Date(`${bitisGunu}T00:00:00.000Z`).getTime() - SURE_UYARI_GUN * 86_400_000).toISOString().slice(0, 10);
}
/**
 * NDT-01 gruplaması (J13): (inspektör, yöntem) başına bütün etkin sertifikalar. Grubun herhangi bir sertifikasında bitiş yoksa grup
 * uyarı vermez (bugünkü kural boş bitişi "süresi geçmemiş" sayar); yoksa yalnız en geç bitiş sayılır (yenisiyle değiştirilmiş eski
 * sertifika uyarı vermez). Yöntemsiz (D-062) satırlar "—" grubudur. Sonuç girdi sırasıyla ilk görülen grup sırasında.
 * D-074 Faz 2: girdi yalnız güncel sertifikalardır (sunucu yerine yenisi geleni okumaz); "Superseded" işaretli bitişsiz eski sertifika
 * grubu susturmaz. Kural değişmedi.
 */
export function ndtSertifikaGruplari(sertifikalar) {
    const gruplar = new Map();
    for (const s of sertifikalar) {
        const yontem = s.yontem?.trim() || "—";
        const k = `${s.inspektorId}\u0000${yontem}`;
        const bitis = s.gecerlilikSonu === null ? null : (s.gecerlilikSonu instanceof Date ? s.gecerlilikSonu.toISOString() : String(s.gecerlilikSonu)).slice(0, 10);
        const g = gruplar.get(k) ?? { inspektorId: s.inspektorId, yontem, bitis: null, bos: false };
        if (!bitis)
            g.bos = true;
        else if (!g.bitis || bitis > g.bitis)
            g.bitis = bitis;
        gruplar.set(k, g);
    }
    return [...gruplar.values()].map((g) => ({ inspektorId: g.inspektorId, yontem: g.yontem, bitis: g.bos ? null : g.bitis }));
}
/** Uyarı anahtarı (karar bu anahtarla saklanır; aynı anahtar yeniden çıktıkça karar geçerlidir). */
export const uyariAnahtari = (...parcalar) => parcalar.join(":");
/** Uyarı cümlelerinin kalıpları (İngilizce anahtar; Türkçesi sözlükte). */
export const UYARI_KALIPLARI = {
    "KAL-04": { doldu: "Calibration expired on {0}.", yaklasiyor: "Calibration expires on {0}." },
    "NDT-01": { doldu: "NDT certificate expired on {0}.", yaklasiyor: "NDT certificate expires on {0}." },
    "WPQ-08": { doldu: "Welder qualification expired on {0}.", yaklasiyor: "Welder qualification expires on {0}." },
    "HT-10": "No accepted hydrotest certificate for {0}.",
    "GEN-16": "Upload a PDF. {0} is not accepted for {1}.",
    "GEN-01": "Already in OASIS: filed as {0} for {1}.",
    "GEN-05": "Type not recognised. Choose a type or file as reference.",
    "GEN-07": "Personal data: visible to PM and System administrator only.",
    "GEN-08": "Prices: visible to PM and System administrator only.",
    /** D-074 Faz 2 (K29): kör yazma tutmadı ya da değer okunamadı; alan boş kaldı (yalnız Documents'te görünür). */
    "GEN-19": "Left empty: {0} could not be read with certainty.",
};
/** Kayıt etiketlerinin kalıpları ("Record" sütunu, zilin başlığı). */
export const KAYIT_ETIKETI_KALIPLARI = { alet: "Instrument {0} · {1}", ndt_inspektor: "NDT inspector {0} · {1}", kaynakci: "Welder {0} · {1}", riser: "{0} · {1}" };
/** GEN-16 cümlesinin değerleri: "Word" ve tür adı (tür yoksa "documents"). */
export const gen16Degerleri = (tur) => ["Word", gelenTuruAdi(tur) ?? "documents"];
/** Kalıbı değerlerle doldurur (olay metni, karar metni, zil; ekran kalıbı sözlükle çevirir). */
export const kalipDoldur = (kalip, degerler) => kalip.replace(/\{(\d+)\}/g, (_, n) => degerler[Number(n)] ?? "");
/**
 * Uyarıyı kim görür (§6.4): KAL-04, NDT-01, WPQ-08 kalite lideri, saha inspektörü, PM, sistem yöneticisi (saha inspektörü fit-up'ta
 * cihaz seçer ve NDT sertifika özetlerini zaten görür, D-064); HT-10 herkes (riser verisi bugün herkese açık). GEN-16 satırın
 * görenleri (satır görünümüyle ayrıca).
 */
export function uyariGorurMu(rol, kod) {
    if (kod === "HT-10" || kod === "GEN-16")
        return true;
    if (kod === "KAL-04" || kod === "NDT-01" || kod === "WPQ-08")
        return yoneticiMi(rol) || kaliteLideriMi(rol) || sahaInspektoruMu(rol);
    return yoneticiMi(rol);
}
/** Zil: kayıt uyarısının "Document alert" öğesini kim alır (§3.17): KAL-04 / NDT-01 / WPQ-08 kalite lideri, PM, sistem yöneticisi; HT-10 saha inspektörü de. */
export function uyariZiliAlirMi(rol, kod) {
    if (yoneticiMi(rol) || kaliteLideriMi(rol))
        return KAYIT_UYARI_KODLARI.includes(kod);
    return kod === "HT-10" && sahaInspektoruMu(rol);
}
/** Zil öğesi sınırı (kişi başına); kalanı tek özet öğesi olur. */
export const BELGE_ZIL_SINIRI = 15;
/* ====================================================================================================================
 * 9 · Satır (API yanıtının birimi, §3.15)
 * ================================================================================================================== */
/** Hedefin açılacağı ekran yolu ("Open where it is filed"). Registers yalnız PM ve sistem yöneticisine açık (bugünkü kural). */
export function hedefYolu(h, rol) {
    if (!h)
        return null;
    switch (h.tur) {
        case "ht":
        case "hat_ndt":
        case "boya": return "/assembly";
        case "proje": return h.kapsam === "riser" && h.anahtar ? `/project-documents/${h.anahtar}` : "/project-documents";
        case "adim_raporu":
        case "pwht":
        case "urun_geldi": return `/komponent/${h.tamirId}`;
        case "weldmap": return `/weldmap/${h.tamirId}`;
        case "kutuk": return yoneticiMi(rol) ? "/kutukler" : null;
        case "donusturucu":
            if (h.aile === "mrb")
                return "/mrb";
            if (h.aile === "sokum")
                return "/sokum";
            if (h.aile === "montaj")
                return h.rn ? `/assembly/${h.rn}` : "/assembly";
            return h.rn ? `/dogrulama/${h.rn}` : "/dogrulama";
    }
}
const isoOku = (v) => (v === null || v === undefined ? null : new Date(v).toISOString());
/** Saklı hedef JSON'u (bozuk ya da eksikse null). Şekil sunucuda yazılırken denetlenir; burada yalnız `tur` alanına bakılır. */
export const hedefOku = (v) => (v && typeof v === "object" && typeof v.tur === "string" ? v : null);
/** Son başarısız deneme (`son_deneme`): {kim, ts, mesaj}; bozuksa null. */
function sonDenemeOku(v) {
    if (!v || typeof v !== "object")
        return null;
    const o = v;
    return typeof o.kim === "string" && typeof o.ts === "string" ? { kim: o.kim, ts: o.ts, mesaj: typeof o.mesaj === "string" ? o.mesaj : "" } : null;
}
/**
 * Satırın kişiye görünen hâli; göremediği satırda null. Maskeli satır (kişisel ya da fiyatlı türde yükleyen) yalnız "Personal
 * document" / "Priced document", yükleme zamanı ve durumu taşır: dosya adı, tür, yer, ipucu ve dosya kimliği yazılmaz.
 * `kopyaAileleri`: aynı baytların gelen kutusu DIŞINDAKİ kaldırılmamış belge satırlarının aileleri (GEN-01; boşsa kopya yok).
 * `kirmiziAcik` (D-074 Faz 2): satırın güncel okumasında kararsız kırmızı uyarı var; maskeli satırda yok sayılır (etiket değişmez).
 */
export function gelenSatiri(i, k, ek, simdi) {
    const gorunum = gelenGorunumu(i, k);
    if (gorunum === "yok")
        return null;
    const durum = GELEN_DURUMLARI.includes(k.durum) ? k.durum : "acik";
    const etiket = gelenEtiketi(k, simdi, gorunum === "tam" && Boolean(ek.kirmiziAcik));
    const sinif = gelenSinifi(k.tur);
    const benim = yukleyenMi(i, k);
    const ortak = { id: k.id, bicim: k.bicim, boyut: k.boyut, sayfaSayisi: k.sayfaSayisi, yukleyen: k.yukleyen, ts: isoOku(k.ts), benim, durum, etiket, sinif };
    const kapanis = durum === "acik" ? null : { kim: k.kapatan ?? "", ts: isoOku(k.kapanisTs) ?? isoOku(k.ts), not: k.not ?? null, sonucDokumanId: k.sonucDokumanId ?? null };
    const hicbiri = { tur: false, dosyala: false, donusturucu: false, referans: false, reddet: false, zatenVar: false };
    if (gorunum === "yuklendi") {
        const acik = durum === "acik" && !baskasiDosyaliyorMu(i, k, simdi);
        return {
            ...ortak, gorunum, ad: null, tur: null, turAdi: sinif === "kisisel" ? "Personal document" : "Priced document", hedef: null, hedefMetni: null, hedefYolu: null,
            ipucu: null, uyarilar: [], dokumanId: null, dosyalayan: null, sonDeneme: null, kapanis: kapanis && { ...kapanis, not: null, sonucDokumanId: null },
            eylemler: { ...hicbiri, reddet: acik && ilkYukleyenMi(i, k) }, bende: false,
        };
    }
    const acik = durum === "acik";
    const baskasi = baskasiDosyaliyorMu(i, k, simdi);
    const tanim = k.tur && gelenTuruMu(k.tur) ? GELEN_TURLERI[k.tur] : null;
    const ipucu = adIpucu(k.ad, BELGE_BICIMLERI.includes(k.bicim) ? k.bicim : null);
    const hedef = hedefOku(k.hedef);
    const uyarilar = [];
    if (acik && k.bicim === "word")
        uyarilar.push({ kod: "GEN-16", renk: "kirmizi", kalip: UYARI_KALIPLARI["GEN-16"], degerler: gen16Degerleri(k.tur) });
    if (acik && ek.kopyaAileleri.length)
        uyarilar.push({ kod: "GEN-01", renk: "gri", kalip: GELEN_ETIKET_ADI.zaten_var, degerler: [] });
    // GEN-05: açık, türsüz, ipucusuz satır; onaylı sayfalardaki gibi (belgeler--faz1-kopya-word) Word satırında GEN-16'nın yanında da
    // çıkar, OASIS'te zaten olan dosyada (GEN-01) çıkmaz: o satırın işi "Remove from this list"tir (U-073 uçtan uca denemesinin bulgusu).
    if (acik && !k.tur && !ipucu && !ek.kopyaAileleri.length)
        uyarilar.push({ kod: "GEN-05", renk: "gri", kalip: UYARI_KALIPLARI["GEN-05"], degerler: [] });
    if (sinif === "kisisel")
        uyarilar.push({ kod: "GEN-07", renk: "gri", kalip: UYARI_KALIPLARI["GEN-07"], degerler: [] });
    if (sinif === "fiyat")
        uyarilar.push({ kod: "GEN-08", renk: "gri", kalip: UYARI_KALIPLARI["GEN-08"], degerler: [] });
    const yazabilir = acik && !baskasi;
    const dosyalanir = yazabilir && k.bicim !== "word" && tanim !== null && tanim.hedef !== null && tanim.kabul.includes(k.bicim) && dosyalayabilirMi(i, k);
    const rezervasyon = rezervasyonAktifMi(k, simdi);
    return {
        ...ortak, gorunum, ad: k.ad, tur: k.tur, turAdi: tanim?.ad ?? null, hedef, hedefMetni: k.hedefMetni, hedefYolu: hedefYolu(hedef, i.rol), ipucu, uyarilar,
        dokumanId: k.dokumanId,
        dosyalayan: acik && rezervasyon && k.dosyalayan ? { ad: k.dosyalayan, ts: isoOku(k.dosyalamaBasTs) } : null,
        sonDeneme: sonDenemeOku(k.sonDeneme),
        kapanis,
        eylemler: {
            tur: yazabilir && turSecebilirMi(i, k),
            dosyala: dosyalanir && tanim.hedef !== "donusturucu",
            donusturucu: dosyalanir && tanim.hedef === "donusturucu",
            referans: yazabilir && referansYapabilirMi(i, k),
            reddet: yazabilir && reddedebilirMi(i, k),
            zatenVar: yazabilir && ek.kopyaAileleri.length > 0 && zatenVarKapatabilirMi(i, k, ek.kopyaAileleri),
        },
        bende: bendeMi(i, k, simdi, gorunum === "tam" && Boolean(ek.kararBende)),
    };
}
//# sourceMappingURL=belgeler.js.map